import { Fragment } from 'react'
import styled from '@emotion/styled'
import { tokens } from '../../theme.js'
import { Button, SecondaryButton, DangerOutlineButton, BoldMedBodyText } from '../styles/index.js'

const colors = tokens.colors

const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${colors.primaryExtraLight};
  border-radius: ${tokens.borderRadius.div};
  padding: 10px 16px 10px 20px;
  margin-bottom: 16px;
  & > p {
    white-space: nowrap;
  }
  & button {
    padding-left: 16px;
    padding-right: 16px;
  }
`
const Actions = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  row-gap: 10px;
`
const ActionDivider = styled.span`
  align-self: stretch;
  width: 1px;
  min-height: 28px;
  margin: 0 4px;
  background: ${colors.sectionDivider};
`

export function SelectionBar({ count, actions = [] }) {
  if (count === 0) return null
  return (
    <Bar data-testid="selection-bar">
      <BoldMedBodyText data-testid="selection-count">{count} selected</BoldMedBodyText>
      <Actions>
        {actions.map(a => {
          const B = a.primary ? Button : a.danger ? DangerOutlineButton : SecondaryButton
          return (
            <Fragment key={a.label}>
              {a.dividerBefore && <ActionDivider aria-hidden="true" data-testid="selection-action-divider" />}
              <B padding="short" onClick={a.onClick} disabled={a.disabled} data-testid={a.testId}>
                {a.icon}
                {a.label}
              </B>
            </Fragment>
          )
        })}
      </Actions>
    </Bar>
  )
}
